var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBenefitsIconGeneration = function SvgBenefitsIconGeneration(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 30,
    height: 30,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 26.25H12.5l1.25-8.75H9.375c-1.1 0-.412-.938-.387-.975 1.612-2.85 4.037-7.1 7.274-12.775h1.25l-1.25 8.75h4.388c.5 0 .775.238.5.825-4.938 8.613-7.4 12.925-7.4 12.925Z",
    fill: "#F9A825"
  })));
};
export default SvgBenefitsIconGeneration;